:host {
  --padding: var(--sportsline-pick-snippet-card-padding, 0.75rem);
  --padding-top: var(--sportsline-pick-snippet-card-padding-top, var(--padding));
  --team-color: var(--sportsline-pick-snippet-card-team-color, #c2c2c2);
  --border-radius: var(--sportsline-pick-snippet-card-border-radius, 0.5rem);
  --card-color-width: var(--sportsline-pick-snippet-card-color-width, 0.375rem);
  font-family: 'FS Industrie', FSIndustrie-Bold, industrie-standard, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--Surface-Primary, #fff);
  padding: var(--padding);
  padding-top: var(--padding-top);
  align-items: start;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius);
  position: relative;

  &,
  & > * {
    box-sizing: border-box;
  }
}

.sportsline-pick-snippet-card__header-branded {
  color: var(--sportsline-pick-snippet-card__header-branded--color, #ffffff);
  background-color: var(--sportsline-pick-snippet-card__header-branded--background, #000000);
  border-radius: 8px 0 8px 0;
  display: flex;
  padding: .50rem .75rem;
  align-items: center;
  gap: 4px;
  position: absolute;
  top: 0;
  left: 0;
}

.sportsline-pick-snippet-card__header-branded__name {
  font-size: 0.75rem;
  font-style: normal;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', 'industrie-standard', Helvetica, Arial, sans-serif;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.022rem;
  text-transform: uppercase;
}

/* BRANDED VARIANT */
.sportsline-pick-snippet-card__header-branded {
  --sportsline-pick-snippet-parlay-card-footer-padding: var(--padding-inline) var(--padding-block);
  --sportsline-pick-snippet-parlay-card-brand-header-background: var(--Brand-Primary);
  --sportsline-pick-snippet-parlay-card-footer-background: var(--Utility-UI-Background-Hover);
  --sportsline-pick-snippet-parlay-card-brand-header-color: var(--Text-Primary, #202121);
}

/* DraftKings */
.sportsline-pick-snippet-card__header-branded--30 {
  --sportsline-pick-snippet-card__header-branded--background: rgba(97, 181, 14, 0.10);
  --sportsline-pick-snippet-card__header-branded--color: #61B50E;
}
/* Caesars */
.sportsline-pick-snippet-card__header-branded--33 {
  --sportsline-pick-snippet-card__header-branded--background: rgba(10, 50, 49, 0.10);
  --sportsline-pick-snippet-card__header-branded--color: #0A3231;
}

/* MGM */
.sportsline-pick-snippet-card__header-branded--34 {
  --sportsline-pick-snippet-card__header-branded--background: rgba(182, 161, 108, 0.10);
  --sportsline-pick-snippet-card__header-branded--color: #B6A16C;
}

/* FanDuel */
.sportsline-pick-snippet-card__header-branded--35 {
  --sportsline-pick-snippet-card__header-branded--background: rgba(20, 147, 255, 0.10);
  --sportsline-pick-snippet-card__header-branded--color: #1493FF;
}

.sportsline-pick-snippet-card {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', 'industrie-standard', Helvetica, Arial, sans-serif;
}

.sportsline-pick-snippet-card__team-color {
  min-height: 100%;
  background-color: var(--sportsline-pick-snippet-card-team-color);
  border-radius: 0 var(--card-color-width) var(--card-color-width) 0;
  width: var(--card-color-width);
  min-width: var(--card-color-width);
}

.sportsline-pick-snippet-card__team-color--over-under {
  background-color: var(--Text-Secondary, #999);
  min-height: 100%;
  border-radius: 0 var(--card-color-width) var(--card-color-width) 0;
  width: var(--card-color-width);
  min-width: var(--card-color-width);
}

.sportsline-pick-snippet-card__content-wrapper {
  display: flex;
  gap: var(--padding);
  width: fit-content;
}

.sportsline-pick-snippet-card__content {
  display: flex;
  align-items: center;
  gap: var(--padding);
}

.sportsline-pick-snippet-card__pick-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.sportsline-pick-snippet-card__pick-label {
  color: var(--Text-Primary, #202121);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.72px;
  text-wrap: pretty;
}

.sportsline-pick-snippet-card__pick-label--odds {
  color: var(--Text-Tertiary, #767676);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  vertical-align: middle;
  margin-left: 0.5rem;
}

.sportsline-pick-snippet-card__market {
  color: var(--Text-Primary, #202121);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  text-transform: capitalize;

  > span:not(:first-child) {
    line-height: 1;
    margin-left: 0.5ch;
  }
}

.sportsline-pick-snippet-card__metadata {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;

  color: var(--Text-Tertiary, #767676);
  font-style: normal;
}

.sportsline-pick-snippet-card__actions {
  margin-left: auto;
  width: 100%;
  &:empty {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  :host {
    padding-left: 0;
    padding-right: 1rem;
    flex-direction: row;
  }
  .sportsline-pick-snippet-card {
    flex-direction: row;
    align-items: center;
  }
  .sportsline-pick-snippet-card__actions {
    width: fit-content;
  }
}
